import React, { useEffect, useState } from "react";
import { fetchNamesIfNeeded, getCachedName } from "../utils/tickerNames";

export default function TickerWithName({ symbol, sep = " - " }) {
    const s = (symbol || "").toUpperCase();
    const [name, setName] = useState(getCachedName(s));

    useEffect(() => {
        let mounted = true;
        (async () => {
            await fetchNamesIfNeeded([s]);
            if (mounted) setName(getCachedName(s));
        })();
        return () => {
            mounted = false;
        };
    }, [s]);

    if (!s) return null;

    return (
        <span className="inline-flex items-baseline">
            {/* 🔥 Animated pulsing gold neon ticker */}
            <span
                className="
                    font-extrabold
                    text-yellow-300
                    text-xlg
                    tracking-wide
                    animate-pulse
                    drop-shadow-[0_0_10px_rgba(255,215,0,0.9)]
                "
            >
                {s}
            </span>

            {/* Company name stays normal */}
            {name && (
                <span className="text-gray-300 ml-1">
                    {sep}
                    {name}
                </span>
            )}
        </span>
    );
}
